import type { Observable } from 'rxjs';
import type { SiteSettings } from '@common/types/site.type';

import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import * as SettingsSelectors from './settings.selectors';

@Injectable()
export class SettingsFacade {
    private readonly store = inject(Store);

    public readonly siteSettings$: Observable<SiteSettings> = this.store.select(SettingsSelectors.selectSiteSettings);
    public readonly showPoweredBy$: Observable<boolean> = this.store.select(SettingsSelectors.selectShowPoweredBy);
    public readonly shopSettings$: Observable<SiteSettings['shop']> = this.store.select(
        SettingsSelectors.selectShopSettings
    );
    public readonly shopCurrency$: Observable<string> = this.store.select(SettingsSelectors.selectShopSettingsCurrency);
    public readonly siteMainPageId$: Observable<string> = this.store.select(SettingsSelectors.selectMainPageId);

    public isPage404$(pageId: string): Observable<boolean> {
        return this.store.select(SettingsSelectors.selectIsPage404(pageId));
    }
}
